import Vue from 'vue';
import SuiVue from 'semantic-ui-vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import EventBus from '@/bus';
import 'ant-design-vue/dist/antd.css';

import '../node_modules/semantic-ui-css/semantic.min.css';
import '@/assets/css/app/scss/app.scss';

// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min.js');
require('froala-editor/js/plugins.pkgd.min.js');

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css');
require('froala-editor/css/froala_style.min.css');
require('froala-editor/css/plugins.pkgd.min.css');

import 'vue-good-table/dist/vue-good-table.css';
import VueFroala from 'vue-froala-wysiwyg';

Vue.use(VueFroala);
Vue.use(SuiVue);
Vue.use(EventBus);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

Vue.config.productionTip = false;
